import React from "react";

import clsx from "clsx";
import { useToasts } from "react-toast-notifications";

import { IconButton } from "@shared/buttons";

export interface TrackingScriptCardProps {
  displayName: string;
  scriptCode: string;
  descriptionHTML: React.ReactElement;
  header: string;
  startExpanded?: boolean;
}

export function OnboardingTrackingScript({
  header,
  descriptionHTML,
  displayName,
  scriptCode,
  startExpanded,
}: TrackingScriptCardProps) {
  const { addToast } = useToasts();
  const [expanded, setExpanded] = React.useState(startExpanded || false);

  return (
    <div>
      <div className={clsx("flex flex-col gap-3")}>
        <p className="card-text">
          <textarea
            style={{ height: "12em", fontFamily: "monospace" }}
            className="form-control text-venus+0"
            readOnly
            value={scriptCode}
          />
        </p>
        <div className="card-text">
          <IconButton
            variant="primary"
            leftIcon={
              <i className="fa-sharp fa-regular fa-link mr-1.5 text-sm" />
            }
            className="font-bold"
            onClick={async () => {
              try {
                await navigator.clipboard.writeText(scriptCode);
                addToast("Copied to clipboard!", { appearance: "success" });
              } catch (err) {
                addToast("Error while coping to clipboard!", {
                  appearance: "error",
                });
              }
            }}
          >
            COPY TO CLIPBOARD
          </IconButton>
        </div>
        <div className="card-text ">{descriptionHTML}</div>
      </div>
    </div>
  );
}
